"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _DraftHeader = _interopRequireDefault(require("../DraftHeader"));
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
  }));
};
PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var emptyButtons = [];
var GenerateMode = function GenerateMode() {
  var isAIDocGenerationEnabled = (0, _exchangeReactHooks.useFeatureFlag)('ai-doc-generation-enabled');
  if (!isAIDocGenerationEnabled) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_DraftHeader.default, {
    buttons: emptyButtons,
    statusText: "Generating documentation",
    statusIcon: /*#__PURE__*/_react.default.createElement(PlusIcon, null)
  });
};
var _default = exports.default = GenerateMode;
//# sourceMappingURL=GenerateMode.js.map